import { render, staticRenderFns } from "./InformeAuditoriaCreateArbitroPopUpPartido.vue?vue&type=template&id=4cf8919e&"
import script from "./InformeAuditoriaCreateArbitroPopUpPartido.vue?vue&type=script&lang=js&"
export * from "./InformeAuditoriaCreateArbitroPopUpPartido.vue?vue&type=script&lang=js&"
import style0 from "./InformeAuditoriaCreateArbitroPopUpPartido.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VDialog,
  VFlex,
  VLayout,
  VSpacer,
  VTextField,
})
